



import {Component, Prop, Vue} from 'vue-property-decorator';
import BackButton from "@/components/Atoms/BackButton/BackButton.vue";

@Component({
  components: { BackButton }
})
export default class RedirectButtonControl extends Vue {
  @Prop({ required: false, type: Boolean, default: false }) isShowBackButton !: boolean

  private onClickToBackButton(): void {
    this.$emit('back')
  }
}
